import { Checkbox, CheckboxProps } from '@headlessui/react';
import React, { ReactNode } from 'react';
import { FaCheck } from 'react-icons/fa6';
import { Trans } from 'react-i18next';
import { twMerge } from 'tailwind-merge';
import { NS_ERROR } from '@/i18n/namespaces';

type CheckboxInputProps = CheckboxProps & {
  label: string | ReactNode;
  error?: string;
  name?: string;
};

export const CheckboxInput = React.forwardRef<
  HTMLInputElement,
  CheckboxInputProps
>(({ label, error, className, name, ...props }, ref) => {
  return (
    <div className="flex w-full flex-col gap-1" data-error-anchor={name}>
      <Checkbox
        className={twMerge('flex gap-2', className as string)}
        ref={ref}
        {...props}
      >
        {({ checked }) => (
          <>
            <div
              className={twMerge(
                'flex size-6 shrink-0 items-center justify-center rounded-lg border',
                checked
                  ? 'border-[#02A340] bg-[#02A340] text-white'
                  : 'border-[#E1E1E1] bg-white',
                props.disabled && 'bg-[#F2F2F2]',
              )}
            >
              {checked && <FaCheck className="size-3.5" />}
            </div>
            <span
              className={twMerge(
                'text-start text-primary',
                props.disabled && 'text-disabled',
              )}
            >
              {label}
            </span>
          </>
        )}
      </Checkbox>
      {error && error !== ' ' && (
        <span className="pl-8 text-xs text-error">
          <Trans ns={NS_ERROR}>{error}</Trans>
        </span>
      )}
    </div>
  );
});

CheckboxInput.displayName = 'CheckboxInput';
